import { useAppAuth } from './UseAppAuth.ts'

export function useMyClub() {
  const { isAuthenticated, user, userLoaded } = useAppAuth()
  // TODO: users in several clubs always resolve to the first one (same rule as
  // the post-login redirect); revisit if a club picker is ever needed.
  const myClub = isAuthenticated ? user?.clubs[0] : undefined
  return {
    isAuthenticated,
    userLoaded,
    myClub,
    myClubPath: myClub ? `/club/${myClub.id}` : undefined,
  }
}
